<script setup>
    import AuthorizationContainer from '@/components/page-authorization/AuthorizationContainer.vue';
    import UserLogin from '@/components/page-authorization/UserLogin.vue';
</script>


<template>
    <AuthorizationContainer>
        <UserLogin/>
    </AuthorizationContainer>
</template>